import React, { Suspense } from 'react';
import {BrowserRouter as Router, Navigate, Route, Routes} from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './App.css';
import Header from './pages/header/header';
import Footer from "./pages/footer/footer";
import { useRoutePreload } from './utils/performance';

// 使用 React.lazy 实现代码分割
const Task = React.lazy(() => import('./pages/task/task'));
const Home = React.lazy(() => import('./pages/home/home'));
const Login = React.lazy(() => import('./pages/login/login'));
const MergeCos = React.lazy(() => import('./pages/home/tools/merge/merge'));
const FormatConvertPage = React.lazy(() => import('./pages/home/tools/conversion/FormatConvertPage'));
const EditingToolsEntry = React.lazy(() => import('./pages/home/tools/editing/index'));
const AdvancedToolsEntry = React.lazy(() => import('./pages/home/tools/advanced/index'));

// 创建工具组件包装器
const ToolWrapper = ({ toolGroup, toolType }) => {
  const ToolGroupComponent = {
    editing: EditingToolsEntry,
    advanced: AdvancedToolsEntry
  }[toolGroup];
  
  if (!ToolGroupComponent) {
    return <div>工具组不存在</div>;
  }
  
  return <ToolGroupComponent toolType={toolType} />;
};

function App() {
    // 预加载路由组件
    const routeComponents = {
        format_convert: () => import('./pages/home/tools/conversion/FormatConvertPage'),
        merge_cos: () => import('./pages/home/tools/merge/merge')
    };
    
    useRoutePreload(routeComponents);
    return (
        <HelmetProvider>
            <Router>
                <div className="App">
                    <Header/>

                    <hr className="divider"/>

                    <div className="content">
                        <Suspense fallback={
                            <div className="loading-container" style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                minHeight: '400px',
                                flexDirection: 'column'
                            }}>
                                <div className="spinner-border text-primary" role="status">
                                    <span className="visually-hidden">加载中...</span>
                                </div>
                                <p className="mt-3 text-muted">页面加载中，请稍候...</p>
                            </div>
                        }>
                            <Routes>
                            {/* 主要页面路由 */}
                            <Route path="/" element={<Home/>}/>
                            <Route path="/home" element={<Navigate to="/" replace/>}/>
                            <Route path="/login" element={<Login/>}/>
                            <Route path="/task" element={<Task/>}/>
                            
                            {/* 工具组路由 - 新的 SEO 友好路由 */}
                            <Route path="/tools/convert" element={<FormatConvertPage />}/>
                            <Route path="/tools/convert/gpx-to-fit" element={<Navigate to="/tools/convert" replace />}/>
                            <Route path="/tools/convert/fit-to-gpx" element={<Navigate to="/tools/convert" replace />}/>
                            <Route path="/tools/convert/gpx-to-kml" element={<Navigate to="/tools/convert" replace />}/>
                            <Route path="/tools/convert/fit-to-kml" element={<Navigate to="/tools/convert" replace />}/>
                            <Route path="/tools/convert/kml-to-gpx" element={<Navigate to="/tools/convert" replace />}/>
                            <Route path="/tools/merge/cos-upload" element={<MergeCos />}/>
                            <Route path="/tools/edit/trim-by-time" element={<ToolWrapper toolGroup="editing" toolType="trim-by-time" />}/>
                            <Route path="/tools/edit/remove-zero-cadence" element={<ToolWrapper toolGroup="editing" toolType="remove-zero-cadence" />}/>
                            <Route path="/tools/edit/trim-by-endtime" element={<ToolWrapper toolGroup="editing" toolType="trim-by-endtime" />}/>
                            <Route path="/tools/edit/repair-fit" element={<ToolWrapper toolGroup="editing" toolType="repair-fit" />}/>
                            
                            {/* 保持原有路由以便兼容，重定向到格式转换单页 */}
                            <Route path="/home/gpx2fit" element={<Navigate to="/tools/convert" replace/>}/>
                            <Route path="/home/fit2gpx" element={<Navigate to="/tools/convert" replace/>}/>
                            <Route path="/home/gpx2kml" element={<Navigate to="/tools/convert" replace/>}/>
                            <Route path="/home/merge" element={<Navigate to="/tools/merge/cos-upload" replace/>}/>
                            <Route path="/home/trim" element={<Navigate to="/tools/edit/trim-by-time" replace/>}/>
                            <Route path="/home/zero-cadence-remove" element={<Navigate to="/tools/edit/remove-zero-cadence" replace/>}/>
                            <Route path="/home/end_time/trim" element={<Navigate to="/tools/edit/trim-by-endtime" replace/>}/>
                        </Routes>
                        </Suspense>
                    </div>

                    <hr className="divider"/>
                    <Footer/>
                </div>
            </Router>
        </HelmetProvider>
    );
}

export default App;
